(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('baseFlotaService', baseFlotaService);

	baseFlotaService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

	function baseFlotaService($http, $q, endPoints, authorization) {
        var service = {
            getList: getList,
            getById: getById,
            add: add,
            deleteById: deleteById
		};

		return service;

        function getList(sorting, filters) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.bases.getList,
                data: { sorting: sorting, filters: filters }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getById(baseId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.bases.getById + '?baseId=' + baseId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function add(base) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.bases.add,
                data: {
                    baseId: base.baseId,
                    id: base.id,
                    nombre: base.nombre,
                    razon: base.razon,
                    nif: base.nif,
                    direccion: base.direccion,
                    poblacion: base.poblacion,
                    cp: base.cp,
                    provincia: base.provincia,
                    pais: base.pais,
                    latitud: base.latitud,
                    longitud: base.longitud,
                    telefono: base.telefono,
                    fax: base.fax,
                    email: base.email,
                    web: base.web,
                    observaciones: base.observaciones,
                    tipo: base.tipo,
                    calendarioId: base.calendarioId,
                    empresaMasterId: base.empresaMasterId
                }

            };
            
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function deleteById(baseIds) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.bases.deleteById,
                data: baseIds
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;

        }

	}

})();